<script setup lang="ts">
const { page } = useAnalytics()
const { createGlobalRegistry } = useGlobalRegistry()
addRouteMiddleware(
  "page_view",
  to => page(to.fullPath),
  { global: true },
)

onMounted(() => {
  createGlobalRegistry()
})

const desktopSafari = ref(false)

onMounted(async () => {
  desktopSafari.value = isDesktop() && await isSafari()
})
</script>

<template>
  <nuxt-layout>
    <nuxt-page />
  </nuxt-layout>
  <div v-if="desktopSafari" class="safari-desktop-window-border" />
</template>
